import cantileverMetalLogo from 'assets/CantileverMetalTransparent.png'
// import { DotPattern } from 'designSystem/components/DotPattern'
import styled from 'styled-components'

const Backdrop = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: min(56rem, 100%);
  height: 11.25rem;
  overflow: hidden;
`

// const PatternMask = styled.div`
//   position: absolute;
//   inset: 0;
//   mask-image: radial-gradient(
//     ellipse 52% 52% at 50% 50%,
//     #fff 0%,
//     rgba(255, 255, 255, 0.9) 24%,
//     rgba(255, 255, 255, 0.45) 48%,
//     transparent 68%
//   );
//   -webkit-mask-image: radial-gradient(
//     ellipse 52% 52% at 50% 50%,
//     #fff 0%,
//     rgba(255, 255, 255, 0.9) 24%,
//     rgba(255, 255, 255, 0.45) 48%,
//     transparent 68%
//   );
// `

const Logo = styled.img`
  position: relative;
  z-index: 1;
  width: 300px;
  height: auto;
`

export const CantileverLandingLogo: React.FC = () => (
  <Backdrop>
    {/* <PatternMask> */}
    {/* <DotPattern glow width={10} height={10} cx={0} cy={0} /> */}
    {/* </PatternMask> */}
    <Logo src={cantileverMetalLogo} alt='Cantilever' />
  </Backdrop>
)
